<template>
  <section>
    <markdown-editor
      :input-text="releaseNotes.info"
      :disabled="readonly"
      @onMediaData="(val) => (releaseNotes.info = val)"
    />
    <v-expansion-panels accordion multiple>
      <v-expansion-panel>
        <v-expansion-panel-header>Features</v-expansion-panel-header>
        <v-expansion-panel-content>
          <template v-for="(feature, index) in releaseNotes.features">
            <div class="note-entry" :key="`feature-${index}`">
              <div class="text-field-container">
                <v-text-field
                  class="text-field"
                  v-model="feature.title"
                  :disabled="readonly"
                  label="Title"
                />
                <v-textarea
                  class="text-field"
                  v-model="feature.description"
                  :disabled="readonly"
                  label="Description"
                />
              </div>
              <v-btn v-if="!readonly" icon small @click="removeFeature(index)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </div>
            <v-divider class="my-2" :key="`feature-divider-${index}`" />
          </template>

          <v-btn
            v-if="!readonly"
            small
            @click="releaseNotes.features.push({ title: '', description: '' })"
          >
            Feature <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-expansion-panel>
        <v-expansion-panel-header>Fixes</v-expansion-panel-header>
        <v-expansion-panel-content>
          <template v-for="(fix, index) in releaseNotes.fixes">
            <div class="note-entry" :key="`fix-${index}`">
              <div class="text-field-container">
                <v-text-field
                  class="text-field"
                  v-model="fix.title"
                  :disabled="readonly"
                  label="Title"
                />
                <v-textarea
                  class="text-field"
                  v-model="fix.description"
                  :disabled="readonly"
                  label="Description"
                />
              </div>
              <v-btn v-if="!readonly" icon small @click="removeFix(index)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </div>
            <v-divider class="my-2" :key="`fix-divider-${index}`" />
          </template>

          <v-btn
            v-if="!readonly"
            small
            @click="releaseNotes.fixes.push({ title: '', description: '' })"
          >
            Fix <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-btn v-if="!readonly" class="mt-3" color="primary" small @click="save">
      Save
    </v-btn>
  </section>
</template>

<script>
export default {
  components: {
    MarkdownEditor: () => import('../common/MarkdownEditor.vue'),
  },
  props: {
    releaseNotes: {
      type: Object,
      default: () => null,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    save() {
      this.$emit('save');
    },
    removeFeature(index) {
      this.releaseNotes.features.splice(index, 1);
    },
    removeFix(index) {
      this.releaseNotes.fixes.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.text-field-container {
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.text-field {
  width: 80%;
}

.note-entry {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
  margin-bottom: 12px;
}
</style>
